export default "__VITE_ASSET__D62VGz8n__"